<template>
  <div>
    <div class="ShowCreateMelkUser">
      <el-scrollbar height="100%" ref="scrollbar">
        <div class="createMelkHeader phoneBookHeader">
          <div class="createMelkHeaderContainer">
            <div class="createMelkHeaderTitle">
              <h1>درخواست های بازدید</h1>
            </div>
            <div class="showFormBtn"></div>
            <div class="ShowIconVsIcon" @click="historyBackHandler">
              <i class="fas fa-arrow-left" style="font-size: 24px"></i>
            </div>
          </div>
        </div>
        <div class="requestVisit">
          <div v-if="!showList" class="visitContainer">
            <div class="contianerHeader">
              <div class="headerTabsWrapper" :class="filter.status">
                <div class="tabSwitch"></div>
                <div class="tabThumb all" @click="selectedTabHandler('all')">
                  همه
                </div>
                <div
                  class="tabThumb approved"
                  @click="selectedTabHandler('approved')"
                >
                  بررسی شده
                </div>
                <div
                  class="tabThumb waitingForReview"
                  @click="selectedTabHandler('waitingForReview')"
                >
                  بررسی نشده
                </div>
              </div>
              <div class="headerFilterWrapper">
                <div class="filterThumb">
                  <el-select placeholder="آخرین درخواست" v-model="filter.sort" @change="onSortChange">
                    <el-option value="" label="آخرین درخواست" />
                    <el-option value="max" label="بیشترین درخواست" />
                    <el-option value="min" label="کمترین درخواست" />
                  </el-select>
                </div>
                <div class="filterThumb">
                  <el-select
                    placeholder="گروه درخواست"
                    v-model="filter.category"
                    @change="getVisitListHandler('first')"
                  >
                    <el-option value="all" label="همه" />
                    <el-option
                      v-for="(v, i) in $store.state.c_set.category"
                      :key="i"
                      :value="i"
                      :label="v"
                    />
                  </el-select>
                </div>
              </div>
            </div>
            <div class="containerMain">
              <div v-if="loading" class="mainList">
                <Skeletor v-for="i in 4" :key="i" class="listThumbSk" />
              </div>
              <div
                v-else-if="!loading && requestList.length > 0"
                class="mainList"
              >
                <div
                  v-for="(v, i) in sortedRequestList"
                  :key="i"
                  class="listThumb"
                  @click="showListHandler(v.id)"
                >
                  <div class="thumbContent">
                    <div class="contentTitle">{{ v.content }}</div>
                    <div class="contentRequests">
                      {{ v.post_visit.length }} درخواست <span class="newRequests" v-if="v.waiting_post_visit != 0">( {{ v.waiting_post_visit }} درخواست جدید )</span>
                    </div>
                    <div class="contentLink">لیست درخواست ها</div>
                  </div>
                  <div class="thumbPic">
                    <img :src="v.avatar" :alt="v.content" />
                  </div>
                </div>
              </div>
              <div
                v-else-if="!loading && requestList.length == 0"
                class="justify-center align-center mt-4"
                style="text-align: center; height: 90%"
              >
                <img
                  src="/img/notfound.png"
                  alt="Alt text"
                  width="320"
                  height="280"
                />
                <h2 class="nothing" style="font-size: 14px">
                  درخواستی یافت نشد!
                </h2>
              </div>
              <div class="loadeMoreLoader" v-if="!loading && loadeMoreLaoding">
                <span class="custom-loader"></span>
              </div>
            </div>
          </div>
          <div v-if="showList" class="visitListContainer">
            <div v-if="requestsLoading" class="containerList">
              <Skeletor class="listThumbSk" v-for="i in 4" :key="i" />
            </div>
            <div
              v-else-if="!requestsLoading && requests.length > 0"
              class="containerList"
            >
              <div v-for="(v, i) in requests" :key="i" class="listThumb">
                <div class="thumbContent">
                  <div class="contentTitle">
                    <div class="titleIcon">
                      <img v-if="v.user_avatar" :src="v.user_avatar" alt="" />
                      <i v-else class="fa-solid fa-user"></i>
                    </div>
                    <span>{{ v.nickname }}</span>
                  </div>
                  <div class="contentDate">
                    <span
                      >زمان ثبت :
                      <span class="strong">{{ v.created_at }}</span></span
                    >
                  </div>
                  <div class="contentPhone">
                    <span>
                      شماره تماس :
                      <span v-if="v.status == 'waitingForReview'" class="strong"
                        >09xxxxxxxxx</span
                      >
                      <span
                        v-if="v.status != 'waitingForReview'"
                        class="strong"
                        >{{ v.mobile }}</span
                      >
                    </span>
                  </div>
                </div>
                <div v-if="v.status == 'waitingForReview'" class="thumbOptions">
                  <div
                    class="optionThumb submitOption"
                    @click="showSubmitHandler(v, i)"
                  >
                    <span>تایید درخواست</span>
                  </div>
                  <div
                    class="optionThumb cancelOption"
                    @click="showCancelHandler(v, i)"
                  >
                    <span>لغو درخواست</span>
                  </div>
                </div>
                <div
                  v-if="v.status != 'waitingForReview'"
                  class="thumbOptions optionResult"
                >
                  <div
                    class="resultThumb submitResult"
                    v-if="v.status == 'approved'"
                  >
                    <span>تاییده شده</span>
                  </div>
                  <div
                    class="resultThumb cancelResult"
                    v-if="v.status == 'disapproved'"
                  >
                    <span>لغو شده</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="loadeMoreLoader"
              v-if="!requestsLoading && requestsLoadeMoreLaoding"
            >
              <span class="custom-loader"></span>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <div class="customSheet" :class="{ active: showCancel || showSubmit }">
      <div class="sheetOverlay" @click="historyBackHandler"></div>
      <div :class="{ show: showCancel }" class="sheetContent canelSheet">
        <div class="contentHeader">
          <div class="headerGrab"></div>
        </div>
        <div class="contentMain">
          <div class="mainTitle">لغو درخواست بازدید</div>
          <div class="mainSubtitle">
            لطفا دلیل خود برای لغو درخواست را وارد کنید
          </div>
          <div class="mainForm">
            <div
              v-if="
                $store.state.c_set &&
                $store.state.c_set.visit_request_msg &&
                $store.state.c_set.visit_request_msg.length > 0
              "
              class="formOptions"
            >
              <Swiper :slides-per-view="'auto'" :space-between="16">
                <SwiperSlide
                  v-for="(v, i) in $store.state.c_set.visit_request_msg"
                  :key="i"
                  @click="setResponseDescHandler(v)"
                >
                  <div class="optionThumb">
                    {{ v }}
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
            <input
              type="text"
              v-model="responseForm.description"
              class="formInput"
              placeholder="دلیل لغو درخواست"
              maxlength="120"
            />
          </div>
          <div class="mainOptions">
            <div
              v-if="!responseLoading"
              class="optionThumb submitOption"
              @click="changeStatusHandler('disapproved')"
            >
              تایید
            </div>
            <div v-if="responseLoading" class="optionThumb submitOption">
              <span class="sheetLoader"></span>
            </div>
            <div class="optionThumb cancelOption" @click="historyBackHandler">
              لغو
            </div>
          </div>
        </div>
      </div>
      <div :class="{ show: showSubmit }" class="sheetContent submitSheet">
        <div class="contentHeader">
          <div class="headerGrab"></div>
        </div>
        <div class="contentMain">
          <div class="mainTitle">تایید درخواست بازدید</div>
          <div class="mainSubtitle">
            لطفاً تاریخ و ساعت دقیق بازدید مورد نظرتان را وارد کنید
          </div>
          <div class="mainForm">
            <div class="formGroup">
              <input
                type="text"
                data-jdp
                class="formInput"
                v-model="responseForm.date"
                placeholder="تاریخ بازدید"
              />
              <el-time-picker
                v-model="responseForm.time"
                placeholder="ساعت بازدید"
                format="HH:mm"
                value-format="HH:mm"
              />
            </div>
            <input
              type="text"
              class="formInput"
              placeholder="توضیحات"
              v-model="responseForm.description"
              maxlength="120"
            />
          </div>
          <div class="mainOptions">
            <div
              v-if="!responseLoading"
              class="optionThumb submitOption"
              @click="changeStatusHandler('approved')"
            >
              تایید
            </div>
            <div v-if="responseLoading" class="optionThumb submitOption">
              <span class="sheetLoader"></span>
            </div>
            <div class="optionThumb cancelOption" @click="historyBackHandler">
              لغو
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@majidh1/jalalidatepicker/dist/jalalidatepicker.min.css";
import { Swiper, SwiperSlide } from "swiper/vue";
import { toast } from "vue3-toastify";
import { Skeletor } from "vue-skeletor";
import "@majidh1/jalalidatepicker";
import "swiper/css";

export default {
  name: "VisitRequest",
  components: {
    Swiper,
    SwiperSlide,
    Skeletor,
  },
  data() {
    return {
      requestList: [],
      requests: [],
      filter: {
        sort: "",
        status: "all",
        category: "all",
        page: 1,
        per_page: 8,
      },
      loading: false,
      loadeMore: true,
      loadeMoreLaoding: false,
      requestsFilter: {
        post_id: null,
        page: 1,
        per_page: 8,
      },
      requestsLoading: false,
      requestsLoadeMore: true,
      requestsLoadeMoreLaoding: false,
      responseForm: {
        status: "",
        date: "",
        time: "",
        description: "",
        post_visit_id: null,
      },
      responseLoading: false,
    };
  },
  computed: {
    showList() {
      const routeList = this.$route.query.list;
      return routeList ? true : false;
    },
    showCancel() {
      const routeCancel = this.$route.query.cancel;
      return routeCancel ? true : false;
    },
    showSubmit() {
      const routeSubmit = this.$route.query.submit;
      return routeSubmit ? true : false;
    },
    sortedRequestList() {
      const list = [...this.requestList];

      if (this.filter.sort === "max") {
        return list.sort((a, b) => b.post_visit.length - a.post_visit.length);
      } else if (this.filter.sort === "min") {
        return list.sort((a, b) => a.post_visit.length - b.post_visit.length);
      }

      return list;
    },
  },
  methods: {
    onSortChange() {
      this.getVisitListHandler("first");
    },
    historyBackHandler() {
      history.back();
      this.responseForm = {
        status: "",
        date: "",
        time: "",
        description: "",
        post_visit_id: null,
      };
    },
    showListHandler(postID) {
      this.$router.push(`/profile/VisitRequest?list=${postID}`);
      this.requestsFilter.post_id = postID;
      this.getVisitRequestsHandler("first");
      document.documentElement.scrollTo({
        top: 0,
        behavior: "instant",
      });
    },
    showSubmitHandler(request, index) {
      const { path, query } = this.$route;
      const newQuery = { ...query, submit: index };

      this.$router.push({
        path,
        query: newQuery,
      });

      this.responseForm.post_visit_id = request.id;
    },
    showCancelHandler(request, index) {
      const { path, query } = this.$route;
      const newQuery = { ...query, cancel: index };

      this.$router.push({
        path,
        query: newQuery,
      });

      this.responseForm.post_visit_id = request.id;
    },
    selectedTabHandler(tab) {
      if (this.filter.status == tab) return;
      this.filter.status = tab;
      this.getVisitListHandler("first");
    },
    getVisitListHandler(params) {
      this.filter.page++;
      this.loadeMore = true;
      this.loadeMoreLaoding = true;

      if (params == "first") {
        this.requestList = [];
        this.loading = true;
        this.filter.page = 1;
      }

      this.helperPost("get-visit-post-list", this.filter)
        .then((response) => {
          if (response.data.result == 1) {
            this.requestList = this.requestList.concat(response.data.data.list);

            if (this.filter.page == response.data.data.total_page) {
              this.loadeMore = false;
            }
          }

          this.loading = false;
          this.loadeMoreLaoding = false;
        })
        .catch((error) => {
          console.log(error);

          this.loading = false;
          this.loadeMoreLaoding = false;
        });
    },
    getVisitRequestsHandler(params) {
      this.requestsFilter.page++;
      this.requestsLoading = true;
      this.requestsLoadeMoreLaoding = true;

      if (params == "first") {
        this.requests = [];
        this.requestsLoading = true;
        this.requestsFilter.page = 1;
      }

      this.helperPost("get-visit-list", this.requestsFilter)
        .then((response) => {
          if (response.data.result == 1) {
            this.requests = this.requests.concat(response.data.data.list);

            if (this.requestsFilter.page == response.data.data.total_page) {
              this.requestsLoadeMore = false;
            }
          }

          this.requestsLoading = false;
          this.requestsLoadeMoreLaoding = false;
        })
        .catch((error) => {
          console.log(error);

          this.requestsLoading = false;
          this.requestsLoadeMoreLaoding = false;
        });
    },
    setResponseDescHandler(text) {
      this.responseForm.description = text;
    },
    changeStatusHandler(status) {
      if (status == "disapproved") {
        if (this.responseForm.description == "") {
          toast("دلیل رد درخواست خود رو وارد کنید.", {
            type: "error",
          });
          return;
        }
      }
      if (status == "approved") {
        if (this.responseForm.date == "") {
          toast("تاریخ بازدید را مشخص کنید.", {
            type: "error",
          });
          return;
        }
        if (this.responseForm.time == "") {
          toast("زمان بازدید را مشخص کنید.", {
            type: "error",
          });
          return;
        }
      }
      this.responseForm.status = status;
      this.responseLoading = true;
      this.helperPost("visit-change-status", this.responseForm)
        .then((response) => {
          if (response.data.result == 1) {
            history.back();
            toast(response.data.msg, {
              type: "success",
            });
            this.requests[
              status == "disapproved"
                ? this.$route.query.cancel
                : this.$route.query.submit
            ].status = status;
            this.responseForm = {
              status: "",
              date: "",
              time: "",
              description: "",
              post_visit_id: null,
            };
          } else {
            toast(response.data.msg, {
              type: "error",
            });
          }
          this.responseLoading = false;
        })
        .catch((error) => {
          console.log(error);
          toast("مشکلی پیش آمده؛ مجدد امتحان کنید.", {
            type: "error",
          });
          this.responseLoading = false;
        });
    },
    handleScroll() {
      const scrollbarWrap = this.$refs.scrollbar?.wrapRef;

      if (!scrollbarWrap) return;

      const scrollTop = scrollbarWrap.scrollTop;
      const scrollHeight = scrollbarWrap.scrollHeight;
      const clientHeight = scrollbarWrap.clientHeight;

      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        if (!this.showList) {
          if (this.loadeMore && !this.loadeMoreLaoding) {
            this.getVisitListHandler();
          }
        } else if (this.showList) {
          if (this.requestsLoading && !this.requestsLoadeMoreLaoding) {
            this.getVisitRequestsHandler();
          }
        }
      }
    },
  },
  mounted() {
    this.getVisitListHandler("first");

    if (this.showList) {
      this.requestsFilter.post_id = this.$route.query.list;
      this.getVisitRequestsHandler("first");
    }

    this.$nextTick(() => {
      const wrap = this.$refs.scrollbar?.wrapRef;
      if (wrap) {
        wrap.addEventListener("scroll", this.handleScroll);
      }
    });

    window.jalaliDatepicker.startWatch({
      maxDate: "attr",
    });
  },
  beforeUnmount() {
    const wrap = this.$refs.scrollbar?.wrapRef;
    if (wrap) {
      wrap.removeEventListener("scroll", this.handleScroll);
    }
  },
};
</script>

<style scoped lang="scss">
.requestVisit {
  padding-top: 72px;

  .visitContainer {
    padding-inline: 5%;

    .contianerHeader {
      margin-bottom: 24px;

      .headerTabsWrapper {
        width: 100%;
        height: 38px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        margin-bottom: 14px;
        border-radius: 12px;
        background: #fff;
        position: relative;
        overflow: hidden;
        border: 1px solid #0096c7;

        &.all {
          .tabSwitch {
            left: 66.666666%;
          }

          .all {
            color: #fff;
          }
        }

        &.approved {
          .tabSwitch {
            left: 33.333333%;
          }

          .approved {
            color: #fff;
          }
        }

        &.waitingForReview {
          .tabSwitch {
            left: 0%;
          }

          .waitingForReview {
            color: #fff;
          }
        }

        .tabSwitch {
          position: absolute;
          inset-block: 0;
          width: 33.333333%;
          z-index: 1;
          background: #0096c7;
          transition: all 0.2s;
        }

        .tabThumb {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.9rem;
          cursor: pointer;
          transition: all 0.2s;
        }
      }

      .headerFilterWrapper {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 14px;

        .filterThumb {
          width: 100%;
          :deep(.el-select) {
            .el-select__wrapper {
              width: 100% !important;
              border: none !important;
              height: 42px !important;
              padding: 0 14px !important;
              border-radius: 12px !important;
              background: #fff !important;
              box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
                0 1px 2px -1px rgba(0, 0, 0, 0.1) !important;
            }
          }
        }
      }
    }

    .containerMain {
      .mainList {
        .listThumbSk {
          width: 100%;
          height: 130px;
          border-radius: 14px;
          background: rgb(146, 221, 238);
          box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);

          &:not(:last-child) {
            margin-bottom: 24px;
          }
        }

        .listThumb {
          width: 100%;
          padding: 18px;
          border-radius: 14px;
          background: #fff;
          box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
          display: flex;
          align-items: flex-start;
          flex-direction: row-reverse;
          justify-content: space-between;
          gap: 18px;
          transition: all 0.3s;

          &:not(:last-child) {
            margin-bottom: 24px;
          }

          &:hover {
            cursor: pointer;
            transform: translateY(-7px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          }

          .thumbContent {
            position: relative;
            flex-grow: 1;

            .contentTitle {
              font-family: "iranyekanB", sans-serif;
              font-size: 0.9rem;
              margin-bottom: 3px;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }

            .contentRequests {
              display: flex;
              align-items: center;
              gap: 4px;
              font-size: 0.9rem;
              color: #575757;
              margin-bottom: 15px;

              &::before {
                content: "";
                display: block;
                width: 4px;
                height: 4px;
                background: #575757;
                border-radius: 9999px;
                flex-shrink: 0;
              }

              .newRequests {
                display: inline-flex;
                align-items: center;
                gap: 4px;
                font-size: 0.7rem;
                color: #f00;
                margin-right: 4px;
                margin-top: -2px;
                font-family: "iranyekanB", sans-serif;
              }
            }

            .contentLink {
              width: 100%;
              height: 36px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-family: "iranyekanB", sans-serif;
              font-size: 0.775rem;
              border-radius: 9px;
              color: #fff;
              background: #0096c7;
            }
          }

          .thumbPic {
            flex-shrink: 0;
            img {
              width: 94px;
              aspect-ratio: 1;
              border-radius: 10px;
              object-fit: cover;
            }
          }
        }
      }
    }
  }

  .visitListContainer {
    padding-inline: 5%;

    .containerList {
      width: 100%;
      padding-block: 6px 28px;

      .listThumbSk {
        width: 100%;
        height: 182px;
        border-radius: 14px;
        background: rgb(146, 221, 238);
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);

        &:not(:last-child) {
          margin-bottom: 24px;
        }
      }

      .listThumb {
        width: 100%;
        padding: 20px;
        border-radius: 14px;
        background: #fff;
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
        transition: all 0.3s;

        &:not(:last-child) {
          margin-bottom: 24px;
        }

        &:hover {
          cursor: pointer;
          transform: translateY(-7px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        .thumbContent {
          margin-bottom: 14px;

          .contentTitle {
            display: flex;
            align-items: center;
            gap: 10px;
            font-family: "iranyekanB", sans-serif;
            font-size: 1.05rem;
            margin-bottom: 8px;

            .titleIcon {
              width: 36px;
              height: 36px;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #0096c738;
              color: #0096c7;
              border-radius: 9999px;
              font-size: 0.85rem;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 9999px;
              }
            }
          }

          .contentDate {
            margin-bottom: 2px;
          }

          .contentDate,
          .contentPhone {
            font-size: 0.85rem;
            color: #575757;
            display: flex;
            align-items: flex-start;
            gap: 8px;
            padding-right: 9px;

            &::before {
              content: "";
              display: block;
              width: 6px;
              height: 1.6px;
              border-radius: 9999px;
              background: #575757;
              margin-top: 12px;
            }

            .strong {
              margin-right: 2px;
              font-family: "iranyekanB", sans-serif;
            }
          }
        }

        .thumbOptions {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 14px;

          &.optionResult {
            grid-template-columns: 100%;
          }

          .optionThumb {
            width: 100%;
            height: 38px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 9px;
            color: #fff;
            font-size: 0.815rem;
            font-family: "iranyekanB", sans-serif;

            &.submitOption {
              background: #0096c7;
            }

            &.cancelOption {
              background: #ef4056;
            }
          }

          .resultThumb {
            width: 100%;
            height: 38px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 9px;
            font-size: 0.815rem;
            font-family: "iranyekanB", sans-serif;

            &.submitResult {
              background: #0096c718;
              color: #0096c7;
            }

            &.cancelResult {
              background: #ef405618;
              color: #ef4056;
            }
          }
        }
      }
    }
  }
}

.customSheet {
  position: fixed;
  z-index: 9999999;
  inset: 0;
  pointer-events: none;

  &.active {
    pointer-events: auto;

    .sheetOverlay {
      opacity: 1;
    }

    .show {
      transform: translateY(0) !important;
    }
  }

  .sheetOverlay {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(1px);
    opacity: 0;
    transition: all 0.2s ease-in;
  }

  .sheetContent {
    position: absolute;
    inset-inline: 0;
    bottom: 0;
    z-index: 2;
    transform: translateY(110%);
    transition: all 0.3s ease-in-out;
    background: #fff;
    border-radius: 24px 24px 0 0;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.15), 0 0 2px rgba(0, 0, 0, 0.1);

    .contentHeader {
      width: 100%;
      padding-block: 16px;

      .headerGrab {
        width: 42px;
        height: 3.4px;
        background: #9a9a9a;
        border-radius: 9999px;
        margin-inline: auto;
      }
    }

    .contentMain {
      padding: 0 24px 28px;

      .mainTitle {
        text-align: center;
        font-size: 1.05rem;
        margin-bottom: 4px;
        font-family: "iranyekanB", sans-serif;
      }

      .mainSubtitle {
        font-size: 0.875rem;
        color: #333;
        text-align: center;
        margin-bottom: 20px;
      }

      .mainForm {
        width: 100%;
        overflow-x: hidden;

        .formOptions {
          cursor: grab;
          margin-bottom: 16px;

          :deep(.swiper) {
            height: fit-content;

            .swiper-wrapper {
              .swiper-slide {
                width: auto !important;
              }
            }
          }

          .optionThumb {
            padding: 10px 24px;
            border-radius: 12px;
            background: #eee;
            color: #575757;
            font-size: 0.85rem;
            white-space: nowrap;
            transition: all 0.15s;

            &:active {
              transform: scale(0.95);
            }
          }
        }

        .formGroup {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 18px;
          margin-bottom: 18px;

          .formInput {
            margin-bottom: 0;
          }
        }

        .formInput {
          position: relative;
          width: 100%;
          height: 48px !important;
          padding: 12px !important;
          font-size: 1rem !important;
          transition: all 0.15s ease-in-out;
          z-index: 1;
          border-radius: 12px !important;
          border: 1px solid rgb(209, 213, 219) !important;
          background: #fff !important;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
          margin-bottom: 24px;

          &::placeholder {
            font-size: 0.85rem;
          }
        }

        :deep(.el-input) {
          .el-input__wrapper {
            width: 100%;
            height: 48px !important;
            padding: 12px !important;
            font-size: 1rem !important;
            transition: all 0.15s ease-in-out;
            z-index: 1;
            border-radius: 12px !important;
            border: 1px solid rgb(209, 213, 219) !important;
            background: #fff !important;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
            margin-bottom: 24px;

            .el-input__prefix {
              display: none !important;
            }

            .el-input__inner {
              color: #000;
              &::placeholder {
                font-size: 0.85rem;
              }
            }
          }
        }
      }

      .mainOptions {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;

        .optionThumb {
          width: 100%;
          height: 46px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 12px;
          color: #fff;
          font-size: 0.9rem;
          font-family: "iranyekanB", sans-serif;

          &.submitOption {
            background: #0096c7;
          }

          &.cancelOption {
            background: #ef4056;
          }
        }
      }
    }
  }
}

.dark {
  .requestVisit {
    .visitContainer {
      .contianerHeader {
        .headerTabsWrapper {
          background: #101a23;
          color: #fff;
        }

        .headerFilterWrapper {
          .filterThumb {
            :deep(.el-select) {
              .el-select__wrapper {
                color: #fff;
                background: #101a23 !important;
                box-shadow: 0 1px 3px 0 rgba(255, 255, 255, 0.1),
                  0 1px 2px -1px rgba(255, 255, 255, 0.1) !important;

                .el-select__selection {
                  .el-select__placeholder {
                    span {
                      color: #fff !important;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .containerMain {
        .mainList {
          .listThumb {
            background: #101a23;
            box-shadow: 0 0 6px rgba(255, 255, 255, 0.15);
            color: #fff;

            .thumbContent {
              .contentRequests {
                color: #ccc;

                &::before {
                  background: #ccc;
                }
              }
            }
          }
        }
      }
    }

    .visitListContainer {
      .containerList {
        .listThumb {
          background: #101a23;
          color: #fff;
          box-shadow: 0 0 6px rgba(255, 255, 255, 0.15);

          .thumbContent {
            .contentDate,
            .contentPhone {
              color: #ccc;
            }
          }
        }
      }
    }
  }
  .customSheet {
    .sheetContent {
      background: #101a23;
      color: #fff;
      box-shadow: 0 0 4px rgba(255, 255, 255, 0.15),
        0 0 2px rgba(255, 255, 255, 0.1);

      .contentMain {
        .mainSubtitle {
          color: #ccc;
        }

        .mainForm {
          .formOptions {
            .optionThumb {
              background: #2a2f33;
              color: #fff;
            }
          }
          .formInput {
            background: #101a23 !important;
            box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1) !important;
            border-color: #2a3b47 !important;
            color: #fff !important;
          }

          :deep(.el-input) {
            .el-input__wrapper {
              background: #101a23 !important;
              box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1) !important;
              border-color: #2a3b47 !important;
              color: #fff !important;

              .el-input__inner {
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.sheetLoader {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #fff;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@media (min-width: 1000px) {
  .requestVisit {
    padding-top: 92px;
    .visitContainer {
      .contianerHeader {
        max-width: 740px;
        margin-inline: auto;
        margin-bottom: 46px;

        .headerTabsWrapper {
          height: 42px;
        }
      }

      .containerMain {
        padding-bottom: 42px;
        .mainList {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 32px;

          .listThumbSk {
            height: 341px;
          }

          .listThumb {
            flex-direction: column-reverse;

            &:not(:last-child) {
              margin: 0;
            }

            .thumbPic {
              img {
                width: 100%;
                aspect-ratio: 3/2;
              }
            }

            .thumbContent {
              width: 100%;
            }
          }
        }
      }
    }

    .visitListContainer {
      .containerList {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 32px;

        .listThumb {
          &:not(:last-child) {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .customSheet {
    &.active {
      .show {
        opacity: 1;
        pointer-events: auto;
        transform: translate(-50%, -50%) !important;
      }
    }

    .sheetContent {
      left: 50%;
      top: 50%;
      bottom: auto;
      right: auto;
      transform: translate(-50%, -46%) !important;
      width: 90%;
      max-width: 512px;
      border-radius: 20px;
      opacity: 0;
      pointer-events: none;

      .contentHeader {
        display: none;
      }

      .contentMain {
        padding-top: 28px;
      }
    }
  }
}
</style>
